// React Components
import React from "react";

// Material UI Components
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';


// Function to insert our Search Name selector (textfield).
export default function SearchNameSelector(props){

    const { tenantId, selectedName, setSelectedName, selectedNameValue, errorSelectedName } = props;

    return(
        
        <Grid item xs={12}>
            {/* User input field control. */}
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'minmax(0, 1fr)', sm: '140px minmax(0, 600px)' }, gap: { xs: 1, sm: 0 }, width: '100%' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <b>Search Name:</b>
                </Box>
                <Box sx={{ minWidth: 0 }}>
                    <TextField                        
                        required
                        name="Search Name Text Field"
                        id="searchNameTextfield"
                        placeholder="Give your search a name (ex. Legal Matter 1)."
                        variant="outlined"
                        size="small"
                        fullWidth
                        inputProps={{ maxLength: 300 }}
                        InputLabelProps={{ shrink: true }}
                        onChange={event => setSelectedName(event.target.value)}
                        inputRef={selectedNameValue}
                        value={selectedName}
                        error={errorSelectedName}
                        helperText={errorSelectedName ? 'Search Name cannot be empty.' : ''}                     
                    />
                </Box>
            </Box>
        </Grid>
    );
};
